export enum AttendeeStatusEnum
{
    ToBeConfirmed = 1,
    Yes = 2,
    No = 3,
    IfRequired = 4,
    Confirmed = 5,
}